import React, { useContext, useEffect, useState } from "react";
import { Button, Space, message, Modal, Spin, Drawer, Row, Col } from "antd";
import { FiltersContext, AuthContext } from "@CONTEXTS";
import { DataTable } from "@MASTER";
import useLogics from "./logics";
import { useGET } from "@API2";
import { DeliveryEndpoints, printBarcode } from "@DELIVERIES";
import { IoIosRefresh } from "react-icons/io";
import { AiOutlineBarcode } from "react-icons/ai";
import PrintModal from "./print-modal";
import { b64toBlob, TermalPrint } from "@HELPERS";
import Returned from "@MODULES/create/returned";

const Table = () => {
  const { pagination, setPageAndLimit, filters } = useContext(FiltersContext);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(true);
  const [printModal, setPrintModal] = useState(false);
  const [printLoading, setPrintLoading] = useState(false);
  const [returnedDrawer, setReturnedDrawer] = useState(null);
  const { info } = useContext(AuthContext);
  const logics = useLogics({
    onPrint: (val) => handlePrint(val),
    onRefresh: () => mutate(),
    onCreateReturned: (record) => setReturnedDrawer(record),
  });

  const {
    data,
    loading: apiLoading,
    mutate,
  } = useGET(
    DeliveryEndpoints.operationDeliveries,
    filters
      ? `?page=${pagination.page}&limit=${pagination.limit}&barcode=${
          Array.isArray(filters.barcode) && filters.barcode.length
            ? encodeURIComponent(JSON.stringify(filters.barcode))
            : filters.barcode
            ? encodeURIComponent(filters.barcode)
            : ""
        }&customerOrderId=${
          filters.customerOrderId ? filters.customerOrderId : ""
        }&notDeliveredOnly=${
          filters.notDeliveredOnly ? filters.notDeliveredOnly : ""
        }&warehouseId=${
          filters.warehouseId ? filters.warehouseId : ""
        }&receiverPersonGsm=${
          filters.receiverPersonGsm ? filters.receiverPersonGsm : ""
        }&status=${filters.status ? filters.status : ""}&merchantId=${
          filters.merchant ? filters.merchant : ""
        }&property=${filters.property ? filters.property : ""}&channel=${
          filters.channel ? filters.channel : ""
        }&startDate=${filters.startDate ? filters.startDate : ""}&endDate=${
          filters.endDate ? filters.endDate : ""
        }
        `
      : false
  );

  useEffect(() => {
    setLoading(apiLoading);
  }, [apiLoading, data]);

  const handlePrint = async (arr) => {
    setLoading(true);
    setPrintLoading(true);
    const response = await printBarcode(arr);
    setLoading(false);
    setPrintLoading(false);
    if (response?.pdf) {
      mutate();
      const b64 = b64toBlob(response.pdf, "application/pdf");
      const blobUrl = URL.createObjectURL(b64);
      setPrintModal(blobUrl);
    }
    if (response?.zplArray) {
      TermalPrint(response?.zplArray);
    }
  };

  return (
    <>
      {printLoading && (
        <Modal visible={printLoading} footer={null} closable={false} centered>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "24px",
              gap: "16px",
            }}
          >
            <Spin size="large" />
            <span>Barkod yazdırılıyor, lütfen bekleyiniz...</span>
          </div>
        </Modal>
      )}
      {printModal && (
        <PrintModal data={printModal} onClose={() => setPrintModal(false)} />
      )}
      <Drawer
        title={
          returnedDrawer?.delivery?.customerDeliveryNo
            ? `Randevulu İade Gönderisi Oluştur - ${returnedDrawer.delivery.customerDeliveryNo}`
            : "Randevulu İade Gönderisi Oluştur"
        }
        placement="right"
        width={1000}
        visible={returnedDrawer}
        onClose={() => setReturnedDrawer(null)}
        destroyOnClose
      >
        <Returned record={returnedDrawer} />
      </Drawer>

      <Row gutter={16}>
        <Col span={24}>
          <div style={{ float: "right" }}>
            <Space>
              <Button
                icon={<AiOutlineBarcode />}
                disabled={selectedRowKeys.length < 1}
                onClick={() => {
                  if (!info.authorities.includes("PRINT_BARCODE")) {
                    return message.error(
                      "Barkod basma yetkiniz bulunmamaktadır!"
                    );
                  }
                  const barcodes = selectedRowKeys.map((item) => {
                    const that = data.rows.find(
                      (x) => x.delivery.customerDeliveryNo === item
                    );
                    return {
                      customerDeliveryNo: that.delivery.customerDeliveryNo,
                      totalParcels: that.delivery.totalParcels,
                    };
                  });
                  handlePrint(barcodes);
                  setSelectedRowKeys([]);
                }}
              >
                Toplu Barkod Yazdır
              </Button>
              <Button icon={<IoIosRefresh />} onClick={() => mutate()}>
                Yenile
              </Button>
            </Space>
          </div>
          <DataTable
            name={
              <div>
                Gönderi Listesi
                <p className="operation-delivery-table-explanation">
                  (Tabloda barkod oluşturulan gönderiler yeşil renk arka plan
                  ile belirtilmiştir.)
                </p>
              </div>
            }
            {...logics}
            dataSource={data?.rows || []}
            loading={loading}
            rowKey={(v) => v.delivery.customerDeliveryNo}
            rowClassName={(record, index) =>
              record.delivery.printBarcode ? "printed-barcode-row" : ""
            }
            // mutate={() => mutate()}
            pagination={{
              pageSizeOptions: [25, 50, 100, 250],
              total: data?.totalRowCount || 0,
              pageSize: pagination.limit,
              current: pagination.page,
              onChange: (page, limit) => {
                setPageAndLimit({ page, limit });
              },
              showSizeChanger: true,
            }}
            rowSelection={{
              selectedRowKeys,
              onChange: (val) => setSelectedRowKeys(val),
              fixed: true,
              columnWidth: 50,
            }}
          />
        </Col>
      </Row>
    </>
  );
};

export default Table;
